/**
 * Created with IntelliJ IDEA.
 * User: elanh
 * Date: 2/21/13
 * Time: 5:38 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var Marionette = require("marionette");
    var TopLevelMenu = require("views/top-level-menu/TopLevelMenu");
    var TrayMenu = require("views/TrayMenu");
    var UserBarWidgetsLayout = require("layouts/UserBarWidgetsLayout");
    var UserBarWidgetsLayoutController = require("controllers/UserBarWidgetsLayoutController");
    /*
     this controller is responsible for controlling the different components of the LiveEngage application
     on start, it displays the LiveEngage layout and sets all its sub-regions
     */
    var LiveEngageUserBarMenuController = Marionette.Controller.extend({
        initialize : function (options) {
            this.LE = options.application;
        },
        show : function (options) {
            this.topLevelMenu = new TopLevelMenu({
                LE: this.LE,
                menuCollection : this.LE.userBarMenu.menuCollection,
                statusCollection : this.LE.userBarMenu.statusCollection,
                model : this.LE.sessionManager.model
            });
            this.trayMenu = new TrayMenu({collection : this.LE.userBarMenu.trayCollection});
            this.userBarWidgetsLayout = new UserBarWidgetsLayout({model : this.LE.sessionManager.model});

            options.topLevelMenu.show(this.topLevelMenu);
            options.trayMenu.show(this.trayMenu);
            options.userBarWidgets.show(this.userBarWidgetsLayout);

            this.LE.userBarWidgetsLayoutController=new UserBarWidgetsLayoutController({
                application:LE,
                userBarWidgetsLayout:this.userBarWidgetsLayout
            });

            this.bindEvents();
        },
        bindEvents: function() {
            this.LE.vent.on("triggerTrayItem", function (trayItemModel) {
                var trayItemView = this.trayMenu.children.findByModel(trayItemModel);
                if (trayItemView) {
                    trayItemView.triggerClick();
                }
            }, this);
        }
    });
    return LiveEngageUserBarMenuController;
});
